import Vue from 'vue'
import Vuex from 'vuex'
import { setTheme} from "@/theme/theme";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    theme: localStorage.getItem("theme") || "dayTheme",
  },
  getters: {
  },
  mutations: {
    setThemeStore(state, theme) {
      setTheme(theme);
    }
  },
  actions: {
  },
  modules: {
  }
})
